import { combineReducers } from 'redux';
import homeReducer from './containers/Home/reducer';

const rootReducer = combineReducers({
  homeReducer,
});

export default rootReducer;
